import { render, staticRenderFns } from "./receiptPlus.vue?vue&type=template&id=bc948358&"
import script from "./receiptPlus.vue?vue&type=script&lang=js&"
export * from "./receiptPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports